import styled from '@emotion/styled';

const Background = styled.div`
  background: #f6f7fa;
  min-height: 100vh;
  color: #141414;
`;

export default Background;
